import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'attendanceSettlementGenerator';

const settlementGeneratorService = {
  getProjects: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/projects`,
      data,
    });
  },

  getAttendanceUsers: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/attendance/users`,
      data,
    });
  },

  createAttendanceSettlement: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/`,
      data,
    });
  },
};
export default settlementGeneratorService;
